import {NewEditForm} from '@pages/pilotage-rh/accounts/components/new-edit-form';

const CreateAccount = () => {
  return <NewEditForm action="create" />;
};

export default CreateAccount;
